import * as React from 'react';
import { connect } from 'react-redux';
import { withRouteData } from 'react-static';
import { Dispatch } from 'redux';

import FaqPageComponent from '../../components/FaqPage/FaqPage';
import { FaqPageLocale } from '../../components/FaqPage/faqPage.locale';
import { openFaq, closeFaq } from './faqPageDuck';
import { RootState } from '../../RootState';
import { RootAction } from '../../RootAction';

interface StateProps {
  openedFaqIndex: number | null;
}

interface DispatchProps {
  openFaq: (index: number) => void;
  closeFaq: () => void;
}

interface FaqPageProps extends StateProps, DispatchProps {
  locale: FaqPageLocale;
}

const FaqPage: React.SFC<FaqPageProps> = props => {
  const toggleFaq = (index: number) => {
    if (index === props.openedFaqIndex) {
      props.closeFaq();
    } else {
      props.openFaq(index);
    }
  };

  return (
    <FaqPageComponent
      locale={props.locale}
      toggleFaq={toggleFaq}
      openedFaqIndex={props.openedFaqIndex}
    />
  );
};

const mapStateToProps = (state: RootState) => ({
  openedFaqIndex: state.faqPage.openedFaqIndex,
});

const mapDispatchToProps = (dispatch: Dispatch<RootAction>) => ({
  openFaq: (index: number) => dispatch(openFaq(index)),
  closeFaq: () => dispatch(closeFaq()),
});

export default withRouteData(
  connect<StateProps, DispatchProps, {}, RootState>(
    mapStateToProps,
    mapDispatchToProps,
  )(FaqPage),
);



// WEBPACK FOOTER //
// /www/client/src/containers/FaqPage/FaqPage.tsx